import { render, staticRenderFns } from "./LocationAndGroups.vue?vue&type=template&id=7b3727b6&scoped=true&"
import script from "./LocationAndGroups.vue?vue&type=script&lang=js&"
export * from "./LocationAndGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3727b6",
  null
  
)

export default component.exports